const FeedbackFormSuccess = () => (
  <div className="c7-subscribe-message">
    <p>Thank you for your feedback.</p>
  </div>
);

export default FeedbackFormSuccess;
